// Adapted from https://stackoverflow.com/a/28056903/15708126
// Given a hex string of the form '#FFFFFF', '#FFF', '#ffffff', or '#fff',
// Returns an array of the form [0-255, 0-255, 0-255]

// This is our default accent color, #3389FF
export const FAILURE_RETURN_COLOR = [51, 137, 255]

export const hexToRGB = (
  colorHex: string,
  failureReturnColor: number[] = FAILURE_RETURN_COLOR,
) => {
  // Tests for valid color Hex codes
  const hexPattern = new RegExp("^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$")
  if (!hexPattern.test(colorHex)) {
    console.error(`hexToRGB Error: failed to parse ${colorHex}`)
    return failureReturnColor
  }

  let r = 0
  let g = 0
  let b = 0

  if (colorHex.length === 4) {
    r = parseInt(`${colorHex[1]}${colorHex[1]}`, 16)
    g = parseInt(`${colorHex[2]}${colorHex[2]}`, 16)
    b = parseInt(`${colorHex[3]}${colorHex[3]}`, 16)
  } else if (colorHex.length === 7) {
    r = parseInt(colorHex.slice(1, 3), 16)
    g = parseInt(colorHex.slice(3, 5), 16)
    b = parseInt(colorHex.slice(5, 7), 16)
  }

  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    console.error(`hexToRGB Error: failed to parse ${colorHex}`)
    return failureReturnColor
  }

  return [r, g, b]
}
